import React, {useState, useEffect } from 'react';
import {Link} from 'react-router-dom';
import Microblading from '../../assets/microheading.png'

import CustomerInfo from '../customer/customer_info_container';

export default function Info(props){

    const { course, setChosenCourse, currentUser } = props


    const [customerInfo, setCustomerInfo] = useState(false)

    useEffect(() => {

    }, [])


    return (
        <div className="slide-in-right">
 
        </div>
    )
    }